export default __webpack_public_path__ + "static/media/cross-24px-FFFFFF.f88fd740.svg";